var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('loading',{attrs:{"loading-key":"loadingKey"}}),(_vm.hasLegacyAccess)?_c('span',{staticClass:"obscure-link",on:{"click":_vm.goToLegacy}},[_vm._v(" Switch to the legacy interface ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }